[
  {
    "version": "0.20.6",
    "date": "2026-10-27",
    "title": "Diagram Rendering Security Hardening",
    "items": [
      { "type": "improvement", "text": "Updated diagram rendering to its latest secure version, hardening diagram previews against known vulnerabilities in the diagram and math-formatting libraries." }
    ]
  },
  {
    "version": "0.20.5",
    "date": "2026-10-27",
    "title": "Page Editor Security Hardening",
    "items": [
      { "type": "improvement", "text": "Updated the page editor to its latest secure version, closing known vulnerabilities in the underlying editing engine so pasted and imported content is handled safely." }
    ]
  },
  {
    "version": "0.20.4",
    "date": "2026-10-27",
    "title": "Security Updates",
    "items": [
      { "type": "improvement", "text": "Updated underlying libraries to their latest secure versions, including routing and build dependencies, to keep the app protected against known vulnerabilities." }
    ]
  },
  {
    "version": "0.20.3",
    "date": "2026-10-22",
    "title": "Email Invites Add People Automatically on Sign-In",
    "items": [
      { "type": "improvement", "text": "People you invite by email with a devtechnology.com address are now added to the board automatically the first time they sign in with that account." },
      { "type": "improvement", "text": "Pending email invitations keep their role and board placement, so an invited teammate lands with the right access the moment they sign in." }
    ]
  },
  {
    "version": "0.20.2",
    "date": "2026-10-21",
    "title": "Invite People by Email",
    "items": [
      { "type": "feature", "text": "You can now invite a devtechnology.com teammate to a board by email before they've opened Flow — we record the invitation and send them a one-time nudge email inviting them to sign in." },
      { "type": "improvement", "text": "Each board has a limit on how many pending email invitations it can hold at once; once it's reached, new invites are declined with a clear message until some are revoked or expire." }
    ]
  },
  {
    "version": "0.20.1",
    "date": "2026-10-21",
    "title": "Clearer Invite Errors",
    "items": [
      { "type": "fix", "text": "When you try to add someone to a board who doesn't have a Flow account yet, you now get a clear \"That person isn't on Flow yet\" message instead of a confusing unknown error." }
    ]
  },
  {
    "version": "0.20.0",
    "date": "2026-10-18",
    "title": "Live Navigation Updates",
    "items": [
      { "type": "feature", "text": "New libraries and pages now appear in the navigation in real time, without needing a refresh." }
    ]
  },
  {
    "version": "0.19.2",
    "date": "2026-10-18",
    "title": "Clearer Library Creation Errors",
    "items": [
      { "type": "fix", "text": "When you try to create a library with a name that's already in use, you now get a clear message that library names must be unique, instead of the form silently doing nothing." }
    ]
  },
  {
    "version": "0.19.1",
    "date": "2026-10-18",
    "title": "Page Live Updates Fixed",
    "items": [
      { "type": "fix", "text": "Live updates and edit-lock notifications now work again when viewing a page another person is editing." }
    ]
  },
  {
    "version": "0.19.0",
    "date": "2026-10-05",
    "title": "Admin MCP Key Worklist & Manual Revoke",
    "items": [
      { "type": "feature", "text": "Admins can now see a worklist of users who still hold AI assistant (MCP) API keys but have been disabled or removed in your identity provider, so stale access is easy to spot." },
      { "type": "feature", "text": "Admins can revoke an individual MCP key directly from the admin console, immediately disabling it." }
    ]
  },
  {
    "version": "0.18.14",
    "date": "2026-09-12",
    "title": "Smoother Sign-In",
    "items": [
      { "type": "fix", "text": "When your session expires or you're signed out, you now land on the CoreFlow sign-in page instead of occasionally being dropped onto the raw identity-provider screen." }
    ]
  },
  {
    "version": "0.18.13",
    "date": "2026-09-12",
    "title": "Real-Time Swimlane Updates",
    "items": [
      { "type": "improvement", "text": "Swimlanes now appear, rename, and archive in real time when a teammate or AI assistant changes them, without needing to refresh the board." }
    ]
  },
  {
    "version": "0.18.12",
    "date": "2026-09-12",
    "title": "Board Stability Fix",
    "items": [
      { "type": "fix", "text": "Fixed a crash that could blank out the board when a card was created or updated in real time (including changes made by AI assistants)." },
      { "type": "improvement", "text": "If a board view ever hits an unexpected error, it now shows a recoverable message with Retry instead of a blank screen." }
    ]
  },
  {
    "version": "0.18.11",
    "date": "2026-08-18",
    "title": "Accessibility Improvements",
    "items": [
      { "type": "improvement", "text": "Admin AI Pipeline panels now announce loading and status updates properly to screen readers." }
    ]
  },
  {
    "version": "0.18.10",
    "date": "2026-08-18",
    "title": "Reliable Real-Time Reconnection",
    "items": [
      { "type": "fix", "text": "Boards now reconnect cleanly after your computer wakes from sleep, instead of getting stuck retrying." },
      { "type": "improvement", "text": "If your session has fully expired, you're now sent to sign in again rather than looping silently." }
    ]
  },
  {
    "version": "0.18.9",
    "date": "2026-08-18",
    "title": "Library Favorites",
    "items": [
      { "type": "feature", "text": "Star your favorite libraries to pin them at the top of the sidebar." },
      { "type": "improvement", "text": "Libraries now sort alphabetically, with favorites always first." },
      { "type": "fix", "text": "H4-H6 headings from markdown now render correctly in Pages." }
    ]
  },
  {
    "version": "0.18.8",
    "date": "2026-08-18",
    "title": "Bug Fixes",
    "items": [
      { "type": "fix", "text": "Subtask reordering now persists correctly after drag-and-drop." },
      { "type": "fix", "text": "Archived cards now appear in the Archived Items panel." },
      { "type": "fix", "text": "Card descriptions set during creation are now saved properly." }
    ]
  },
  {
    "version": "0.18.7",
    "date": "2026-08-18",
    "title": "Mermaid Diagrams",
    "items": [
      { "type": "feature", "text": "Create Mermaid diagrams in Pages — insert a code block with language 'mermaid' and see a live SVG preview rendered below." }
    ]
  },
  {
    "version": "0.18.6",
    "date": "2026-08-14",
    "title": "Delete Libraries & Archive Pages",
    "items": [
      { "type": "feature", "text": "Library admins can now delete a library and all its pages from Library Settings." },
      { "type": "feature", "text": "Archive pages via the MCP server for AI-assisted cleanup." }
    ]
  },
  {
    "version": "0.18.5",
    "date": "2026-08-14",
    "title": "Page Reordering & MCP Improvements",
    "items": [
      { "type": "feature", "text": "Drag and drop pages in the sidebar to reorder or nest them — drop at the top/bottom edge to reorder, drop in the middle to nest." },
      { "type": "feature", "text": "Show description on card: toggle a checkbox in the card detail to display the first two lines of description on the board." },
      { "type": "feature", "text": "MCP server now routes writes through the BFF for full consistency — assignments trigger avatars and notifications correctly." },
      { "type": "fix", "text": "Page nesting via drag-and-drop now persists correctly." }
    ]
  },
  {
    "version": "0.18.4",
    "date": "2026-08-10",
    "title": "Paste Markdown & MCP Write Tools",
    "items": [
      { "type": "feature", "text": "Paste raw markdown into the page editor and it automatically converts to rich formatted blocks (headings, lists, bold, code, etc.)." },
      { "type": "feature", "text": "MCP server now supports write operations: create cards, swimlanes, libraries, and pages with full markdown support." },
      { "type": "fix", "text": "Public library overview page no longer shows an access error for non-members." }
    ]
  },
  {
    "version": "0.18.3",
    "date": "2026-08-05",
    "title": "Library Access Controls",
    "items": [
      { "type": "fix", "text": "Public read-only libraries now correctly enforce read-only access — non-members can view pages but cannot edit or save." },
      { "type": "improvement", "text": "The page editor clearly shows when you have read-only access with a banner and disabled editing controls." }
    ]
  },
  {
    "version": "0.18.2",
    "date": "2026-08-05",
    "title": "Avatar Fix on Assign",
    "items": [
      { "type": "fix", "text": "Assignee avatars now appear immediately when you add someone to a card — no page refresh needed." }
    ]
  },
  {
    "version": "0.18.1",
    "date": "2026-08-05",
    "title": "Restore Archived Swimlanes",
    "items": [
      { "type": "feature", "text": "View and restore archived swimlanes from the Archived Items panel — cards that were archived with the swimlane are automatically restored too." }
    ]
  },
  {
    "version": "0.18.0",
    "date": "2026-08-03",
    "title": "Watch for Changes",
    "items": [
      { "type": "feature", "text": "Watch boards, cards, libraries, and pages to get notified when things change — even if you're not directly assigned." },
      { "type": "feature", "text": "Manage all your watches from Profile > Watching." },
      { "type": "improvement", "text": "Watch notifications appear in the notification bell with an eye icon so you know why you were notified." }
    ]
  },
  {
    "version": "0.17.3",
    "date": "2026-08-03",
    "title": "Avatar Fix",
    "items": [
      { "type": "fix", "text": "Card assignee avatars now load reliably — no more missing photos on board cards." }
    ]
  },
  {
    "version": "0.17.2",
    "date": "2026-07-31",
    "title": "Connect Your AI Assistant",
    "items": [
      { "type": "feature", "text": "Connect AI assistants like Kiro to CoreFlow — go to Profile > AI Assistant Keys, create a key, and your assistant can search your wiki and browse boards." },
      { "type": "improvement", "text": "AI assistants can now list your boards, view cards, search wiki content by meaning, and explore concept connections." }
    ]
  },
  {
    "version": "0.17.1",
    "date": "2026-07-31",
    "title": "Personal MCP API Keys",
    "items": [
      { "type": "feature", "text": "Create personal API keys for AI assistants — give Kiro or other tools access to search and browse your wiki." },
      { "type": "improvement", "text": "MCP keys are scoped to your library access — assistants can only see what you can see." }
    ]
  },
  {
    "version": "0.17.0",
    "date": "2026-07-31",
    "title": "AI-Powered Knowledge Base",
    "items": [
      { "type": "feature", "text": "Semantic search — find content by meaning, not just keywords. Toggle the 'AI' button in the search bar." },
      { "type": "feature", "text": "Related pages sidebar — see pages connected to the current page through shared concepts." },
      { "type": "feature", "text": "AI-generated page summaries — collapsible summary card showing key themes at the top of each page." },
      { "type": "feature", "text": "Concept browser — explore all topics across the knowledge base and drill down to see which pages discuss each concept." },
      { "type": "feature", "text": "MCP server — AI assistants can now query the wiki knowledge base for search, page retrieval, and topic summaries." }
    ]
  },
  {
    "version": "0.16.0",
    "date": "2026-07-30",
    "title": "Advanced Search",
    "items": [
      { "type": "feature", "text": "Advanced Search modal — search archived cards, filter by list, swimlane, label, assignee, or due date range." },
      { "type": "feature", "text": "Search results now show the list name, swimlane, and a snippet of where the match was found (description, label, or custom field)." },
      { "type": "improvement", "text": "Open Advanced Search from the search bar's 'Advanced' button or with Ctrl+Shift+F." }
    ]
  },
  {
    "version": "0.15.2",
    "date": "2026-07-30",
    "title": "Sprint Report Widget Available",
    "items": [
      { "type": "fix", "text": "Sprint Report is now selectable as a chart type when creating analytics dashboard widgets." }
    ]
  },
  {
    "version": "0.15.1",
    "date": "2026-07-30",
    "title": "Template Editor UX Improvement",
    "items": [
      { "type": "improvement", "text": "Notification template editor now shows a compact list in board settings — click any event type to open the full editor in a modal." }
    ]
  },
  {
    "version": "0.15.0",
    "date": "2026-07-30",
    "title": "Custom Notification Templates",
    "items": [
      { "type": "feature", "text": "Board owners can now customize email notification templates — write your own subject and body with {{variables}} for each event type." },
      { "type": "feature", "text": "Live preview shows how the email will look as you edit the template, with sample data filled in." },
      { "type": "improvement", "text": "Notification emails now show the actual person who performed the action (e.g., 'John Janek assigned you') instead of 'CoreFlow'." }
    ]
  },
  {
    "version": "0.14.0",
    "date": "2026-07-29",
    "title": "Sprint Metrics & Velocity Tracking",
    "items": [
      { "type": "feature", "text": "Set start and end dates on swimlanes to define sprint boundaries — dates display in the swimlane header with an 'Active' badge for the current sprint." },
      { "type": "feature", "text": "New Sprint Report showing stories committed, completed, and carried over for each sprint, with a trailing 3-sprint average trend line." },
      { "type": "feature", "text": "Sprint Report supports story points — configure a points field to see points-based metrics alongside card counts." },
      { "type": "improvement", "text": "Sprint dates are editable from the swimlane menu — set, update, or clear dates at any time." }
    ]
  },
  {
    "version": "0.13.4",
    "date": "2026-07-29",
    "title": "Card Assignee & Custom Field Fixes",
    "items": [
      { "type": "fix", "text": "Assignee avatars now display correctly on cards — shows your photo or initials with name on hover." },
      { "type": "fix", "text": "The 'Linked to List' custom field now appears immediately when a card is created, without needing a page refresh." },
      { "type": "fix", "text": "Adding a 'Linked to List' field to a board now backfills the value for all existing cards automatically." }
    ]
  },
  {
    "version": "0.13.3",
    "date": "2026-07-29",
    "title": "Assignee Avatars on Cards",
    "items": [
      { "type": "feature", "text": "Card assignees now show as avatars directly on the board — hover to see who's assigned." }
    ]
  },
  {
    "version": "0.13.2",
    "date": "2026-07-29",
    "title": "Page Navigation Fix",
    "items": [
      { "type": "fix", "text": "Switching between pages no longer occasionally shows blank content or stale text from the previous page." }
    ]
  },
  {
    "version": "0.13.1",
    "date": "2026-07-29",
    "title": "Public Boards Visual Consistency",
    "items": [
      { "type": "improvement", "text": "Public boards now display as colored tiles matching the style of your personal boards for a consistent home page experience." },
      { "type": "fix", "text": "Public boards now correctly appear in the public boards section after setting visibility to public." }
    ]
  },
  {
    "version": "0.13.0",
    "date": "2026-07-29",
    "title": "Export Boards to Jira",
    "items": [
      { "type": "feature", "text": "Export any board as a Jira-compatible archive — import directly into Jira Data Center, including air-gapped instances with no internet." },
      { "type": "feature", "text": "Export includes cards, descriptions, comments, labels, custom fields, checklists (as subtasks), and file attachments." },
      { "type": "feature", "text": "A step-by-step import guide is bundled in the archive so your Jira admin knows exactly what to do." }
    ]
  },
  {
    "version": "0.12.1",
    "date": "2026-07-24",
    "title": "Search Now Finds Card Descriptions",
    "items": [
      { "type": "feature", "text": "Board search now matches words in card descriptions, not just titles — so you can find cards by their content." },
      { "type": "improvement", "text": "Description matches show a snippet of the matching text so you can see why a card appeared in results." }
    ]
  },
  {
    "version": "0.12.0",
    "date": "2026-07-24",
    "title": "Smarter Board Search",
    "items": [
      { "type": "improvement", "text": "Search now matches multiple words independently — searching 'auth login' finds cards with both words anywhere in the title, labels, or members." },
      { "type": "improvement", "text": "Results are ranked by relevance — title matches appear first, then card numbers, labels, members, and custom fields." },
      { "type": "improvement", "text": "Search results now show the card number, labels, and why a card matched when the match is not in the title." },
      { "type": "improvement", "text": "Matching text is highlighted in search results for easier scanning." },
      { "type": "fix", "text": "Search input no longer fires on every keystroke — a short delay reduces flicker while typing." }
    ]
  },
  {
    "version": "0.11.1",
    "date": "2026-07-24",
    "title": "Analytics — Linked to List Dimension & Dashboard Fix",
    "items": [
      { "type": "feature", "text": "Group analytics widgets by 'Linked to List' to see card distribution across lists in your sprint dashboards." },
      { "type": "fix", "text": "Dashboards no longer crash when loading widget data." }
    ]
  },
  {
    "version": "0.11.0",
    "date": "2026-07-24",
    "title": "Linked to List Custom Field",
    "items": [
      { "type": "feature", "text": "New 'Linked to List' custom field type that automatically shows which list a card is in." },
      { "type": "improvement", "text": "The field value updates instantly when you drag a card to a different list or when a list is renamed." }
    ]
  },
  {
    "version": "0.10.2",
    "date": "2026-07-24",
    "title": "Attachment Download Confirmation",
    "items": [
      { "type": "improvement", "text": "Clicking an attachment now shows a confirmation modal with file details before downloading." },
      { "type": "fix", "text": "Attachment downloads no longer fail silently due to pop-up blockers." }
    ]
  },
  {
    "version": "0.10.1",
    "date": "2026-07-20",
    "title": "Analytics for Program Managers — Burndown, Velocity & More",
    "items": [
      { "type": "feature", "text": "Sprint burndown charts show remaining work vs. ideal pace over your sprint date range." },
      { "type": "feature", "text": "Velocity charts track cards or story points completed per sprint with a trailing average line." },
      { "type": "feature", "text": "Cycle time and lead time histograms help identify bottlenecks in your delivery process." },
      { "type": "feature", "text": "WIP aging chart shows card counts per column with color-coded status against your WIP limits." },
      { "type": "feature", "text": "Cumulative flow diagrams visualize how work accumulates across columns over time." },
      { "type": "feature", "text": "Dashboard templates — create a Sprint Health or Kanban Flow dashboard with one click." },
      { "type": "feature", "text": "Board preparation wizard guides you through adding the right custom fields and marking done lists for analytics." },
      { "type": "improvement", "text": "All dashboard widgets now render live charts immediately — no more placeholder content." },
      { "type": "improvement", "text": "Historical card data is now tracked over time, enabling point-in-time and date-range analytics." }
    ]
  },
  {
    "version": "0.10.0",
    "date": "2026-07-18",
    "title": "Board Analytics — Dashboards, Charts & Data Export",
    "items": [
      { "type": "feature", "text": "New Analytics section in the top navigation bar — access all your dashboards from one place." },
      { "type": "feature", "text": "Create, organize, and share analytics dashboards with your team using private or public visibility." },
      { "type": "feature", "text": "Guided widget builder with 6 chart types — bar, line, pie, stacked bar, horizontal bar, and data table." },
      { "type": "feature", "text": "Analyze card data across multiple boards with configurable dimensions and measures." },
      { "type": "feature", "text": "Export widget data as CSV or full dashboards as PDF reports." },
      { "type": "feature", "text": "Click any chart element to drill down and see the individual cards behind the numbers." }
    ]
  },
  {
    "version": "0.9.6",
    "date": "2026-07-17",
    "title": "Pages Editor Fixes — Images, Code Blocks & Toolbar",
    "items": [
      { "type": "fix", "text": "Uploaded images and files no longer break after 15 minutes — they now stay permanently accessible." },
      { "type": "fix", "text": "Code blocks now support multiple lines — press Enter to add new lines, and paste multi-line code without it escaping the block." },
      { "type": "fix", "text": "The editor toolbar stays visible at the top when scrolling long pages." },
      { "type": "fix", "text": "You can now click below images and files to continue typing." },
      { "type": "feature", "text": "Text color and highlight color pickers in the toolbar — choose from 8 colors to emphasize important content." },
      { "type": "feature", "text": "See who else is viewing a page with avatar bubbles on the toolbar — no more accidentally overwriting each other's work." },
      { "type": "improvement", "text": "Right-click pages in the sidebar for a context menu with Rename, New Child, and Archive options." },
      { "type": "improvement", "text": "Inline code now has a visible background and border so it stands out from regular text." },
      { "type": "improvement", "text": "Hover over truncated page names in the sidebar to see the full title in a tooltip." },
      { "type": "improvement", "text": "The 'Show Panel' button now says 'Show History & Comments' so you know what's inside." }
    ]
  },
  {
    "version": "0.9.5",
    "date": "2026-07-17",
    "title": "@Mentions, Number Fields & Card UX Fixes",
    "items": [
      { "type": "feature", "text": "Type @ in card comments to mention teammates — a dropdown shows board members and inserts their name. Mentioned users receive a notification." },
      { "type": "feature", "text": "New 'Number' custom field type — supports decimals and large values for tracking quantities, budgets, or measurements." },
      { "type": "improvement", "text": "@mentions are now highlighted in rendered comments so they stand out visually." },
      { "type": "improvement", "text": "Card descriptions now auto-save as you type, with an orange 'Auto-saving...' and green 'Saved' indicator so you always know the status." },
      { "type": "fix", "text": "Card descriptions no longer collapse formatting — line breaks and whitespace are preserved correctly." },
      { "type": "fix", "text": "Label chips on cards now have proper spacing and padding so text is fully legible." }
    ]
  },
  {
    "version": "0.9.4",
    "date": "2026-07-15",
    "title": "Markdown in Comments",
    "items": [
      { "type": "feature", "text": "Comments now render markdown — URLs become clickable links, and **bold**, *italic*, `code`, ~~strikethrough~~, and code blocks all display with formatting." }
    ]
  },
  {
    "version": "0.9.3",
    "date": "2026-07-15",
    "title": "Page Auto-Save & Archive",
    "items": [
      { "type": "feature", "text": "Pages now auto-save 2 seconds after you stop typing — no more losing work if you forget to hit Save." },
      { "type": "feature", "text": "Archive pages from the sidebar by hovering over a page and clicking the archive icon — empty pages are deleted automatically." }
    ]
  },
  {
    "version": "0.9.2",
    "date": "2026-07-10",
    "title": "Move Card Modal, Subtask Assignment & Conflict Handling",
    "items": [
      { "type": "feature", "text": "Move cards between lists and swimlanes via a modal — hover over a card and click the ↗ button instead of dragging." },
      { "type": "feature", "text": "Subtasks can now be assigned directly from the subtask list without opening the subtask card." },
      { "type": "improvement", "text": "Assigning someone to a subtask automatically adds them to the parent card's assignees." },
      { "type": "improvement", "text": "Unassigning from a subtask prompts whether to also remove from the parent card." },
      { "type": "fix", "text": "Rapidly toggling card assignees no longer fails — the backend retries on version conflicts automatically." },
      { "type": "fix", "text": "Board list sections (All Boards, Shared, Public) no longer have a huge gap between them." }
    ]
  },
  {
    "version": "0.9.1",
    "date": "2026-07-10",
    "title": "Real-Time Sync & Custom Fields Fixes",
    "items": [
      { "type": "fix", "text": "Real-time updates now work — card changes by one user appear instantly for all other users on the same board." },
      { "type": "fix", "text": "Custom field definition changes (create, edit, delete) now propagate to other users in real time." },
      { "type": "fix", "text": "Custom field values no longer overwrite each other when editing multiple fields on the same card." },
      { "type": "fix", "text": "Custom field definitions can now be deleted after creation." },
      { "type": "improvement", "text": "Field type can be changed after creation as long as no cards have values set for that field." },
      { "type": "improvement", "text": "Dropdown options in custom field definitions can be reordered with up/down controls." },
      { "type": "fix", "text": "Open card detail view now reflects changes made by other users in real time." },
      { "type": "fix", "text": "Filter bar dropdowns no longer flash in the top-left corner before positioning correctly." }
    ]
  },
  {
    "version": "0.9.0",
    "date": "2026-07-08",
    "title": "Custom Fields, Enhanced Search & Unified Filters",
    "items": [
      { "type": "feature", "text": "Add custom fields to your boards — choose from boolean, dropdown (single or multi-select), and text types, with up to 20 fields per board." },
      { "type": "feature", "text": "Custom field values now appear directly on mini-cards when enabled with the Show on Card toggle." },
      { "type": "improvement", "text": "Search now finds cards by custom field values, including text content, dropdown options, and boolean field names." },
      { "type": "improvement", "text": "All filters live in a single scrollable toolbar row, including new custom field filters for dropdown and boolean fields." }
    ]
  },
  {
    "version": "0.8.2",
    "date": "2026-07-07",
    "title": "Card Assignment Fix",
    "items": [
      { "type": "fix", "text": "Card assignment now works reliably — fixed a race condition where duplicate API calls could conflict." }
    ]
  },
  {
    "version": "0.8.1",
    "date": "2026-07-07",
    "title": "Library Access & Sharing Dialog",
    "items": [
      { "type": "feature", "text": "Libraries now have an Access & Sharing dialog matching boards — manage visibility, search users, and assign roles from one place." },
      { "type": "improvement", "text": "Adding members to a library now uses type-ahead search instead of requiring a user ID." },
      { "type": "fix", "text": "User name resolution in library settings is significantly faster." }
    ]
  },
  {
    "version": "0.8.0",
    "date": "2026-07-07",
    "title": "Public Visibility Modes",
    "items": [
      { "type": "feature", "text": "Boards and libraries now support three visibility modes: Private, Public (view only), and Public (can edit)." },
      { "type": "feature", "text": "Discover public boards and libraries shared across the organization from the new Public Boards section." },
      { "type": "improvement", "text": "Non-member users see a clear read-only banner when viewing public boards they can't edit." }
    ]
  },
  {
    "version": "0.7.2",
    "date": "2026-07-07",
    "title": "Swimlane Reordering & Toolbar Overflow Menu",
    "items": [
      { "type": "feature", "text": "Reorder swimlanes using Move Up / Move Down in the swimlane ⋮ menu." },
      { "type": "feature", "text": "New swimlane creation now uses a modal dialog instead of an inline form." },
      { "type": "improvement", "text": "Toolbar buttons collapse into a ⋯ overflow menu, keeping the header compact on all screen sizes." },
      { "type": "fix", "text": "Activity sidebar now opens correctly in calendar view." }
    ]
  },
  {
    "version": "0.7.1",
    "date": "2026-07-06",
    "title": "Editable Start Date on Cards",
    "items": [
      { "type": "feature", "text": "You can now set and edit a Start Date on cards, right above the Due Date field." }
    ]
  },
  {
    "version": "0.7.0",
    "date": "2026-07-06",
    "title": "Filter Redesign & Full-Text Card Search",
    "items": [
      { "type": "feature", "text": "Search now finds cards by title, card number, label name, or assigned member name." },
      { "type": "improvement", "text": "Filters redesigned with consistent popover dropdowns, checkmarks on selected items, and count badges." },
      { "type": "improvement", "text": "Removed duplicate Members filter — the Assignee filter handles member filtering." },
      { "type": "improvement", "text": "Board title and description sit side-by-side in the header to save vertical space." },
      { "type": "fix", "text": "Search results dropdown no longer appears behind the filter toolbar." },
      { "type": "fix", "text": "Member/assignee filters now correctly match cards by user identity instead of avatar URLs." }
    ]
  },
  {
    "version": "0.6.5",
    "date": "2026-06-26",
    "title": "Calendar UX & Breadcrumb Improvements",
    "items": [
      {
        "type": "improvement",
        "text": "Calendar cells now have a consistent height — busy days show \"+X more\" that opens a floating overlay with the full card list."
      },
      {
        "type": "improvement",
        "text": "Click any card in the calendar to open its detail view directly."
      },
      {
        "type": "fix",
        "text": "Calendar card clicks were being blocked by an invisible overlay — now all cards and buttons respond to clicks correctly."
      },
      {
        "type": "fix",
        "text": "Breadcrumbs (title bar) now update reliably when navigating between boards and pages."
      }
    ]
  },
  {
    "version": "0.6.4",
    "date": "2026-06-25",
    "title": "Teams Integration Setup Guide & Team Allowlist",
    "items": [
      {
        "type": "feature",
        "text": "Admin Teams integration now shows a step-by-step setup guide for configuring the Entra app."
      },
      {
        "type": "feature",
        "text": "Admins can restrict which teams are available for board-level channel selection using the new allowlist."
      }
    ]
  },
  {
    "version": "0.6.3",
    "date": "2026-06-23",
    "title": "Per-Board Teams Channels & Admin Fixes",
    "items": [
      {
        "type": "feature",
        "text": "Board admins can now configure a dedicated Teams channel for each board — open Board Settings to set it up."
      },
      {
        "type": "feature",
        "text": "Test Connection button available at the board level to verify Teams channel configuration before saving."
      },
      {
        "type": "fix",
        "text": "Admin notification settings now save correctly when toggling channel or preference checkboxes."
      },
      {
        "type": "fix",
        "text": "Admin notifications page no longer crashes when delivery statistics are not yet available."
      }
    ]
  },
  {
    "version": "0.6.2",
    "date": "2026-06-23",
    "title": "Pages UX Polish",
    "items": [
      {
        "type": "improvement",
        "text": "Image, video, and file insert buttons now open a file picker and upload directly — no more empty placeholder blocks."
      },
      {
        "type": "feature",
        "text": "Delete block button (✕) in the toolbar removes the current block instantly — no need to reload if you insert something by mistake."
      },
      {
        "type": "fix",
        "text": "Show panel no longer crashes when revision history or cross-links return empty results."
      },
      {
        "type": "fix",
        "text": "Table gear menu, page rename, and all panel components now handle API responses gracefully."
      }
    ]
  },
  {
    "version": "0.6.1",
    "date": "2026-06-23",
    "title": "Integration Test Buttons & Teams Fix",
    "items": [
      {
        "type": "feature",
        "text": "Test Connection button for each integration (Microsoft Graph, Slack, Teams) — validate your credentials before saving."
      },
      {
        "type": "fix",
        "text": "Microsoft Teams integration now accepts Team ID and Channel ID instead of requiring a deprecated webhook URL."
      }
    ]
  },
  {
    "version": "0.6.0",
    "date": "2026-07-01",
    "title": "Mentions, Discussions & Media Inserts",
    "items": [
      {
        "type": "feature",
        "text": "Type @ in the editor to mention teammates — shows a filterable dropdown and inserts a styled mention link."
      },
      {
        "type": "feature",
        "text": "Discussion panel — open the side panel and switch to the Discussion tab to leave comments on any page."
      },
      {
        "type": "feature",
        "text": "Insert image, video, and file attachment blocks directly from the editor toolbar."
      },
      {
        "type": "improvement",
        "text": "Right panel now uses tabs (Details and Discussion) for a cleaner layout."
      }
    ]
  },
  {
    "version": "0.5.2",
    "date": "2026-06-23",
    "title": "Pages Editor & Sharing Enhancements",
    "items": [
      {
        "type": "feature",
        "text": "Full-featured editor toolbar with block quotes, code blocks, toggles, tables, dividers, checklists, text alignment, and indent/outdent."
      },
      {
        "type": "feature",
        "text": "Double-click any page title to rename it inline — works in both the sidebar tree and the content header."
      },
      {
        "type": "feature",
        "text": "Library settings panel lets you toggle visibility (public/private) and manage members with role assignments."
      },
      {
        "type": "feature",
        "text": "Table management with drag handles for rows and columns, plus add/remove operations."
      },
      {
        "type": "improvement",
        "text": "Slash menu (/) now surfaces all block types including tables, toggles, and media embeds."
      },
      {
        "type": "fix",
        "text": "Page titles now reject non-printable control characters to prevent rendering issues."
      }
    ]
  },
  {
    "version": "0.5.1",
    "date": "2026-06-24",
    "title": "Pages Editor Stability Fixes",
    "items": [
      {
        "type": "fix",
        "text": "Page editor no longer crashes when loading page content."
      },
      {
        "type": "fix",
        "text": "Page breadcrumbs now show the correct title instead of a UUID while loading."
      }
    ]
  },
  {
    "version": "0.5.0",
    "date": "2026-06-23",
    "title": "Pages: History, Search, Templates & Real-Time Updates",
    "items": [
      {
        "type": "feature",
        "text": "Revision history panel — view past edits, compare two revisions side-by-side, and restore any previous version."
      },
      {
        "type": "feature",
        "text": "Cross-link panel — link pages to boards and cards for easy navigation between modules."
      },
      {
        "type": "feature",
        "text": "Page templates — choose from built-in or custom templates when creating a new page."
      },
      {
        "type": "feature",
        "text": "Full-text search across pages with highlighted matches and snippet previews."
      },
      {
        "type": "feature",
        "text": "Real-time collaboration banner — see when another user updates the page you're viewing."
      },
      {
        "type": "improvement",
        "text": "Public library visibility banner warns when content is shared with all team members."
      }
    ]
  },
  {
    "version": "0.4.0",
    "date": "2026-06-23",
    "title": "Rich Text Page Editor",
    "items": [
      {
        "type": "feature",
        "text": "Rich text editor for wiki pages with formatting toolbar — headings, bold, italic, lists, code blocks, and links."
      },
      {
        "type": "feature",
        "text": "Wiki links — type [[ to link between pages with autocomplete suggestions."
      },
      {
        "type": "feature",
        "text": "Image upload — paste or drag images directly into the editor."
      },
      {
        "type": "improvement",
        "text": "Save with Ctrl+S and see unsaved changes indicator in the toolbar."
      }
    ]
  },
  {
    "version": "0.3.0",
    "date": "2026-06-23",
    "title": "Teams Graph Integration & What's New Improvements",
    "items": [
      {
        "type": "feature",
        "text": "Teams integration via Graph API — connect your Teams channel with team and channel IDs instead of webhooks. Notifications are delivered as Adaptive Cards."
      },
      {
        "type": "feature",
        "text": "What's New dialog — see release notes on first login after updates. Previous releases available in the accordion below."
      },
      {
        "type": "improvement",
        "text": "Avatar now displays in the app title bar alongside your name."
      },
      {
        "type": "fix",
        "text": "Admin link now appears immediately after login without needing to click."
      }
    ]
  },
  {
    "version": "0.2.0",
    "date": "2026-06-22",
    "title": "Calendar View, Link Visualization & Real-Time Sync",
    "items": [
      {
        "type": "feature",
        "text": "Calendar view — switch between List and Calendar views to see cards by due date. Supports month/week layouts, drag-to-reschedule, and break-out to a new tab."
      },
      {
        "type": "feature",
        "text": "Card link visualization — hover over a card to see colored lines connecting it to linked cards. Hold Shift to expand one more hop in the dependency chain."
      },
      {
        "type": "feature",
        "text": "Real-time board sync — card and list changes from other users now appear instantly without manual refresh."
      },
      {
        "type": "feature",
        "text": "Inline editing — double-click list titles or subtask titles to rename them directly."
      },
      {
        "type": "feature",
        "text": "Comment editing — edit your own comments after posting. Edited comments show an (edited) indicator."
      },
      {
        "type": "feature",
        "text": "Profile avatars — your Microsoft 365 photo is automatically pulled and displayed across the app."
      },
      {
        "type": "improvement",
        "text": "Assignee display — cards now show 'Assigned to' with a single name and avatar. You can remove assignees with the ✕ button."
      },
      {
        "type": "fix",
        "text": "Archived cards no longer reappear on page refresh."
      },
      {
        "type": "fix",
        "text": "Restored cards now display their title correctly."
      },
      {
        "type": "fix",
        "text": "Display names no longer show as UUIDs on the profile page."
      }
    ]
  }
]
